import { Link } from 'react-router'
import { Button } from '@structural-climbing/ui'
import { NavDot, type DotKind } from '../nav/NavDot'

interface Props {
  label: string
  /** The current value, greyed on the right: "Activ", "Română". */
  value?: string
  /** A red dot beside the label when something here needs doing. */
  dot?: DotKind | false
  /** A page to go to. */
  to?: string
  /** Or a sheet to open. */
  onPress?: () => void
  /** Sign out: red, and no chevron, since it goes nowhere. */
  danger?: boolean
}

/**
 * One line of the profile's settings list, like a phone's: what it is on the
 * left, its current value and a chevron on the right.
 */
export function SettingsRow({ label, value, dot, to, onPress, danger = false }: Props) {
  const content = (
    <>
      <span className={`flex flex-1 items-center gap-2 ${danger ? 'text-danger' : ''}`}>
        {label}
        {dot && <NavDot kind={dot} />}
      </span>
      {value && <span className="truncate text-foreground/45">{value}</span>}
      {!danger && (
        <span aria-hidden className="text-lg leading-none text-foreground/35">
          ›
        </span>
      )}
    </>
  )
  const className =
    'h-auto min-h-14 w-full justify-start gap-2 rounded-none bg-transparent px-5 py-4 text-left text-[15px] font-normal data-[hover=true]:bg-[var(--gym-veil)]'

  // A plain router link, so it reads as a link: it goes somewhere.
  if (to) {
    return (
      <Link
        to={to}
        className={`flex items-center transition-colors hover:bg-[var(--gym-veil)] ${className}`}
      >
        {content}
      </Link>
    )
  }
  return (
    <Button variant="light" disableRipple className={className} onPress={onPress}>
      {content}
    </Button>
  )
}
